export default {
    callable: (element: HTMLElement) => {
        const lazyImgEles = element.querySelectorAll('img[data-src]');
        [].forEach.call(lazyImgEles, (ele: HTMLImageElement) => {
            ele.src = ele.getAttribute('data-src') || '';
            ele.removeAttribute('data-src');
        });
    },
};
